import {useTranslation} from "./LocalizationProvider";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, {useState} from "react";
import {
    AppBar, Breadcrumbs, Divider,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography
} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {nativePostMessage} from "./NativeInterface";
import {sessionActions} from "../../store";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import makeStyles from "@mui/styles/makeStyles";
import admixlogo from '../../resources/images/admixlogo.png';

const useStyles = makeStyles((theme) => ({
    desktopRoot: {
        height: '100%',
        display: 'flex',
    },
    mobileRoot: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    desktopDrawerPaper: {
        width: "100%",
        height: "80px",
        flexDirection: 'row',
        backgroundColor: "black",
        color: "#fafafa",
        display: "flex",
        justifyContent: "space-between"
    },
    mobileDrawer: {
        width: theme.dimensions.drawerWidthTablet,
        flexDirection: 'column',
    },
    mobileToolbar: {
        zIndex: 1,
    },
    content: {
        flexGrow: 1,
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    },
}));

const PageTitle = ({breadcrumbs}) => {
    const theme = useTheme();
    const t = useTranslation();

    const desktop = useMediaQuery(theme.breakpoints.up('md'));

    if (desktop) {
        return (
            <Typography variant="h6" noWrap>{t(breadcrumbs[0])}</Typography>
        );
    }
    return (
        <Breadcrumbs>
            {breadcrumbs.slice(0, -1).map((breadcrumb) => (
                <Typography variant="h6" color="inherit" key={breadcrumb}>{t(breadcrumb)}</Typography>
            ))}
            <Typography variant="h6" color="textPrimary">{t(breadcrumbs[breadcrumbs.length - 1])}</Typography>
        </Breadcrumbs>
    );
};

const CustomMenuComponent = ({menu, breadcrumbs, children}) => {

    const t = useTranslation();
    const location = useLocation();
    // const admin = useAdministrator();
    const theme = useTheme();
    const phone = useMediaQuery(theme.breakpoints.down('md'));

    const desktop = useMediaQuery(theme.breakpoints.up('md'));
    const [openDrawer, setOpenDrawer] = useState(false);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const user = useSelector((state) => state.session.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const getUsernameFromLocalStorage = () => {
        var userEmail = JSON.parse(localStorage.getItem('loginName'))
        return userEmail
    }
    const handleLogout = async () => {
        setAnchorEl(null);

        const notificationToken = window.localStorage.getItem('notificationToken');
        if (notificationToken) {
            window.localStorage.removeItem('notificationToken');
            const tokens = user.attributes.notificationTokens?.split(',') || [];
            if (tokens.includes(notificationToken)) {
                const updatedUser = {
                    ...user,
                    attributes: {
                        ...user.attributes,
                        notificationTokens: tokens.length > 1 ? tokens.filter((it) => it !== notificationToken).join(',') : undefined,
                    },
                };
                await fetch(`/api/users/${user.id}`, {
                    method: 'PUT',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(updatedUser),
                });
            }
        }
        await fetch('/api/session', {method: 'DELETE'});
        nativePostMessage('logout');
        navigate('/login');
        dispatch(sessionActions.updateUser(null));
    };
    const handleHome = () => {
        setAnchorEl(null);
        navigate(`/home`);
    };

    return desktop ? (
        <div className={classes.desktopRoot}>
            <Drawer
                variant="permanent"
                classes={{paper: classes.desktopDrawerPaper}}
            >
                <List sx={{
                    // selected and (selected + hover) states
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: '#414141'
                    },
                    // hover states
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: '#666666'
                    },
                }}
                      style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: "0 0 0 100px"}}>
                    <Box
                        style={{cursor: "pointer", paddingRight: "20px"}}
                        component="img"
                        sx={{
                            maxHeight: {xs: 233, md: 167},
                            maxWidth: {xs: 350, md: 250},
                        }}
                        alt="admix logo"
                        onClick={handleHome}
                        src={admixlogo}
                        />
                    <ListItemButton component={Link} to={"/home"} selected={location.pathname === '/home'}>
                        <ListItemText primary={t('homePage')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/"} selected={location.pathname === '/'}>
                        <ListItemText primary={t('monitoring')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/settings/preferences"}
                                    selected={location.pathname === '/settings/preferences'}>
                        <ListItemText primary={t('settingsTitle')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/reports/route"}
                                    selected={location.pathname === '/reports/route'}>
                        <ListItemText primary={t('reportTitle')}/>
                    </ListItemButton>
                </List>
                <List sx={{
                    // selected and (selected + hover) states
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: '#414141'
                    },
                    // hover states
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: '#666666'
                    },
                }}
                    style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: "0 100px 0 0"}}>
                    <ListItemButton component={Link} to={`/settings/user/${user.id}`}
                                    selected={location.pathname === `/settings/user/${user.id}`}>
                        <ListItemText primary={t('greetUser') + ", " + getUsernameFromLocalStorage() + "!"}/>
                    </ListItemButton>
                    <ListItemButton onClick={handleLogout}>
                        <ListItemText primary={t('loginLogout')}/>
                    </ListItemButton>
                </List>
            </Drawer>
            <div style={{width: "100%"}}>
                <div className={classes.content}
                     style={{paddingTop: "80px", paddingBottom: "80px", minHeight: "100%"}}>{children}</div>
                <div style={{height: "52px", marginTop: "-60px", backgroundColor: "lightgrey"}}>
                    <hr style={{borderWidth: 1, color: "lightgray"}}/>
                    <center style={{fontSize: "0.9rem"}}>
                        © {new Date().getFullYear()} Admix Monitoring System
                    </center>
                </div>
            </div>
        </div>
    ) : (
        <div className={classes.mobileRoot}>
            <Drawer
                variant="temporary"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                classes={{paper: classes.mobileDrawer}}
            >
                <List style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: 0}}>
                    <ListItemButton component={Link} to={"/"} selected={location.pathname === '/'} style={{backgroundColor: "transparent"}}>
                            <Box
                                style={{cursor: "pointer"}}
                                component="img"
                                sx={{
                                    maxWidth: {xs: 200, md: 200},
                                    marginTop: "10px"
                                }}
                                alt="admix logo"
                                src={admixlogo}
                            />
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/home"} selected={location.pathname === '/home'}>
                        <ListItemText primary={t('homePage')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/"} selected={location.pathname === '/'}>
                        <ListItemText primary={t('monitoring')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/settings/preferences"}
                                    selected={location.pathname === '/settings/preferences'}>
                        <ListItemText primary={t('settingsTitle')}/>
                    </ListItemButton>
                    <ListItemButton component={Link} to={"/reports/route"}
                                    selected={location.pathname === '/reports/route'}>
                        <ListItemText primary={t('reportTitle')}/>
                    </ListItemButton>
                    <Divider/>
                    <ListItemButton component={Link} to={`/settings/user/${user.id}`}
                                    selected={location.pathname === `/settings/user/${user.id}`}>
                        <ListItemText primary={t('settingsUser')}/>
                    </ListItemButton>
                    <ListItemButton onClick={handleLogout}>
                        <ListItemText primary={t('loginLogout')}/>
                    </ListItemButton>
                </List>
            </Drawer>
            <AppBar className={classes.mobileToolbar} position="static" color="inherit">
                <Toolbar>
                    <IconButton color="inherit" edge="start" sx={{mr: 2}} onClick={() => setOpenDrawer(true)}>
                        <MenuIcon/>
                    </IconButton>
                    <PageTitle breadcrumbs={breadcrumbs} />
                </Toolbar>
            </AppBar>
            <div className={classes.content} style={{minHeight: "100%"}}>{children}</div>
        </div>
    );
};

export default CustomMenuComponent;
